<script lang="ts">
	import { getOptimizedCmsImageUrl } from '@app/utils/cms';
	import Avatar from '$lib/elements/Avatar.svelte';
	export let authors: any;
</script>

<div
	class="flex md:justify-start justify-center {authors.length !== 1
		? 'translate-x-3 md:translate-x-0'
		: ''} mb-3"
>
	{#each authors as author, index}
		{#if author?.content.avatar.filename}
			<Avatar
				imageUrl={getOptimizedCmsImageUrl(author?.content.avatar.filename, '250x250')}
				size="big"
				border="none"
				alt={author?.name}
				classNames="min-w-[120px] min-h-[120px] {index + 1 === authors.length &&
				authors.length !== 1
					? '-translate-x-1/3'
					: ' '}"
			/>
		{/if}
	{/each}
</div>

{#each authors as author}
	<p class="font-semibold text-xl font-display p-0">
		{author?.content.firstName + ' ' + author?.content.lastName}
	</p>
	{#if author?.content.job}
		<p>{author?.content.job}</p>
	{/if}
{/each}
